$(document).ready(function() {

  $('.js-add-favorite').on('ajax:success', function(e) {
    [data, status, xhr] = e.detail;
    $(this).toggleClass('o-options__fav-active');
  })

});
